// src/app/core/mainPage/mainPagecomp/VideoSection/TvCard.tsx
interface TvCardProps {
  src: string;
  name: string;
  description: string;
  onTry: () => void;
}

export function TvCard({ src, name, description, onTry }: TvCardProps) {
  return (
    <div onClick={onTry} className="cursor-pointer group">
      <div className="relative rounded-2xl overflow-hidden border border-white/20 dark:border-white/20 transition-all duration-200 hover:border-white/40 dark:hover:border-white/40">
        <div className="relative w-full aspect-video">
          <img src={src} alt={name} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
          <h3 className="text-lg font-bold drop-shadow-lg">{name}</h3>
          <p className="text-sm text-white/80 leading-relaxed mt-1 line-clamp-2 drop-shadow">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}